import { Dialog } from "primereact/dialog";
import { Interview_Process, IRequirementMast, Job_Type, Req_Priority, Req_Term } from "../../models/RequirementMast";
import { IAllRequirements } from "../../models/AllRequirements";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../shared/Fetch";
// import { Req } from "../../shared/Req";
import { IReq_Update } from "../../models/Requirement_Update";
import { format } from "date-fns";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { ILogin, } from "../../models/Login";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";

interface Iprops {
    singleData: IAllRequirements
    open: boolean,
    hideDialog: () => void,
    toast: any,
    typePOC?: boolean
}

interface IReqJDUnderstandings {
    id?: number,
    req_ID?: number,
    aI_Response?: string,
    aI_Response_Hindi?: string,
    created_Date?: Date,
    is_Active?: boolean,
}

export const Publish = (props: Iprops) => {
    // const [data, setData] = useState<IRequirementMast[]>([]);
    const [updatedData, setUpdatedData] = useState<IReq_Update[]>([]);
    const [hasAudio, setHasAudio] = useState(false);
    const [jdUnderstanding, setJdUnderstanding] = useState({
        aI_Response: `Look for a Senior Java Developer.
The candidate should have 5 years of experience.
Strong Spring Boot experience is required.`} as IReqJDUnderstandings);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [openJDUn, setOpenJDUn] = useState(false);
    const [currentWordIndex, setCurrentWordIndex] = useState(-1);
    const [englishWords, setEnglishWords] = useState<string[]>([]);
    const [hindiWords, setHindiWords] = useState<string[]>([]);
    const [selectedLanguage, setSelectedLanguage] = useState<"en" | "hi">("en");
    const langs = [
        { name: 'Hindi', code: 'hi' },
        { name: 'English', code: 'en' }
    ];
    // const [additional_info,setAdditional_info] = useState("");
    // const [loading, setLoading] = useState(false);

    // const loadData = async () => {
    //     setLoading(true);
    //     const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
    //     if (response) {
    //         const data: IRequirementMast[] = await response.json();
    //         setData(data);
    //         setLoading(false);
    //     } else setLoading(false);
    // }
    const loadUpdatedData = async () => {
        // setLoading(true);
        const response = await Fetch("Requirement_MAST/reqUpdate", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: IReq_Update[] = await response.json();
            // data.reverse();
            data.forEach(d => {
                d.req = JSON.parse(d.details);
            });
            if (data.length > 0) setUpdatedData(data);
            else {
                const response2 = await Fetch(`Requirement_MAST/${(props?.typePOC != null && props?.typePOC != undefined && props?.typePOC === true) ? "byIdPOC" : "byId"}`, "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
                if (response2) {
                    const data2: IRequirementMast = await response2.json();
                    const _tempData: IReq_Update = {
                        req_ID: data2.req_ID,
                        updatedOn: data2.req_PostedDateAndTime,
                        req: data2,
                        details: ""
                    }
                    setUpdatedData([_tempData]);
                }
            }
        }
        // setLoading(false);
    }

    const onHide = () => {
        setSelectedLanguage("en");
        setUpdatedData([]);
        props.hideDialog();
        setHasAudio(false);
    }

    const checkAudio = async () => {
        const response = await Fetch("Resume_Mast/audio", "GET", null, `req_id=${props.singleData.req_ID}`, null);
        if (response) setHasAudio(true);
    }

    const footerTemplate = () => {
        return hasAudio ? <div style={{ display: 'flex' }}>
            <audio src={`${baseUrl}${"Resume_Mast/audio"}?req_id=${props.singleData.req_ID}`} controls></audio>
        </div> : '';
    }

    const getJDunderstanding = async () => {
        const response = await Fetch("Requirement_MAST/getJDUnderstandings", "GET", null, `reqID=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: any = await response.json();
            const text = data?.aI_Response || "";
            const text2 = data?.aI_Response_Hindi || "";

            if (text) {
                setEnglishWords(text.split(/\s+/));
                setCurrentWordIndex(-1);
            }
            if (text2) {
                setHindiWords(text2.split(/\s+/));
                setCurrentWordIndex(-1);
            }
            setJdUnderstanding(data);
        }
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    const getFemaleVoice = () => {
        const voices = window.speechSynthesis.getVoices();

        // Prefer common female English voices
        // const preferredNames = [
        //     "Microsoft Jenny Online (Natural) - English (United States)",
        //     "Microsoft Aria Online (Natural) - English (United States)",
        //     "Google US English Female",
        //     "Samantha"
        // ];

        // return (
        //     voices.find(v =>
        //         preferredNames.some(name =>
        //             v.name.toLowerCase().includes(name.toLowerCase())
        //         )
        //     ) ||
        //     voices.find(v =>
        //         v.lang.startsWith("en") &&
        //         /female|woman|jenny|aria|samantha/i.test(v.name)
        //     ) ||
        //     voices.find(v => v.lang === "en-US") ||
        //     voices.find(v => v.lang.startsWith("en"))
        // );

        if (selectedLanguage === "hi") {
            // First try Hindi voices
            return (
                voices.find(v =>
                    v.lang.toLowerCase() === "hi-in"
                ) ||
                voices.find(v =>
                    v.lang.toLowerCase().startsWith("hi")
                )
            );
        }

        return (voices.find(v =>
            /Jenny.*Natural|Aria.*Natural/i.test(v.name)
        ) ||
            voices.find(v =>
                /female|samantha|zira|jenny|aria/i.test(v.name)
            ));
    };

    const speakText = (text: string) => {
        if (!("speechSynthesis" in window)) {
            alert("Text-to-speech is not supported in this browser.");
            return;
        }

        // Stop previous speech
        window.speechSynthesis.cancel();

        const utterance = new SpeechSynthesisUtterance(text);

        utterance.lang = selectedLanguage === "en" ? "en-US" : "hi-IN";
        utterance.rate = 0.88;
        utterance.pitch = 1.15;
        utterance.volume = 1;

        const femaleVoice = getFemaleVoice();

        if (femaleVoice) {
            utterance.voice = femaleVoice;
        }

        utterance.onstart = () => {
            setIsSpeaking(true);
            setIsPaused(false);
            setCurrentWordIndex(0);
        };

        utterance.onboundary = (event) => {
            console.log("BOUNDARY:", event.name, event.charIndex);
            if (event.name === "word") {
                const spokenText = text.substring(0, event.charIndex);

                const wordIndex = spokenText
                    .trim()
                    .split(/\s+/).length - 1;

                setCurrentWordIndex(wordIndex);
            }
        };

        utterance.onend = () => {
            setIsSpeaking(false);
            setIsPaused(false);
            setCurrentWordIndex(-1);
        };

        utterance.onerror = () => {
            setIsSpeaking(false);
            setIsPaused(false);
            setCurrentWordIndex(-1);
        };

        window.speechSynthesis.speak(utterance);
    };

    const pauseSpeaking = () => {
        if (
            window.speechSynthesis.speaking &&
            !window.speechSynthesis.paused
        ) {
            window.speechSynthesis.pause();

            setIsPaused(true);
        }
    };

    const resumeSpeaking = () => {
        if (!window.speechSynthesis.paused) {
            return;
        }

        window.speechSynthesis.resume();
        setIsPaused(false);
    };

    const stopSpeaking = () => {
        window.speechSynthesis.cancel();

        setIsSpeaking(false);
        setIsPaused(false);
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="View JD Explanation" onClick={() => setOpenJDUn(true)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate2 = () => {
        return (
            <React.Fragment>
                <Dropdown value={selectedLanguage} onChange={(e) => {
                    stopSpeaking();
                    setSelectedLanguage(e.value || "en");
                }} options={langs} optionLabel="name" optionValue="code" editable placeholder="Select a language" className="w-full md:w-14rem" />
            </React.Fragment>
        );
    };

    useEffect(() => {
        if (props.singleData.req_ID && props.open) {
            // loadData();
            // if (props.singleData.requirement_Update) 
            loadUpdatedData();
            checkAudio();
            getJDunderstanding();
            // else setUpdatedData([]);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} footer={footerTemplate} header={<span>Details of Requirement ID - {(props?.typePOC != null && props?.typePOC != undefined && props?.typePOC === true) ? "" : props.singleData.req_ID}</span>} className="p-fluid" onHide={onHide} maximizable>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            {/* <Req req={data} loading={loading} /> */}
            {/* <CKEditor editor={ClassicEditor} data={data[0]?.req_JobDescription} disabled /> */}
            {updatedData.length === 0 && <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><h4>Loading...</h4></div>}
            {updatedData.map((ud, index) => {
                // let date;
                // // let str = ud.req?.additional_info ? ud.req?.additional_info.split(">")[1].split("<")[0] : "";
                // // setAdditional_info(ud.req?.additional_info || "");
                // if (ud.updatedOn) date = format(new Date(ud.updatedOn), 'dd/MM/yyyy hh:mm a').toUpperCase();
                // else date = "";
                let date = "";
                if (ud.updatedOn) {
                    const d = new Date(ud.updatedOn);
                    date = safeFormatDate(d.toDateString(), "dd/MM/yyyy", DateFormat) + " " + format(d, "hh:mm a").toUpperCase();
                }

                const parser = new DOMParser();
                const html = parser.parseFromString(ud.req?.additional_info || "<p>No Job Description</p>", 'text/html');
                const body = html.body.innerText;

                const location = ud.req?.city_Name ? `${ud.req?.city_Name || ''}, ${ud.req?.state_Name || ''}` : '';
                return <div className="mb-3" key={ud.req_Update_ID}>
                    <h6 className="text-primary">{index === updatedData.length - 1 ? "Posted On" : "Updated On"} - {date}</h6>
                    <JVSunEditor value={`<table>
    <thead>
        <th>Job Title</th>
        <th>Duration</th>
        <th>Location</th>
        <th>Job Type</th>
        <th>Rate/Salary</th>
        <th>End Client</th>
        <th>Industry</th>
        <th>Job Term</th>
        <th>Positions</th>
        <th>Skills Category</th>
        <th>Priority</th>
        <th>Travel</th>
        <th>Work Authorization</th>
        <th>Interview Process</th>
        <th>Skills Required</th>
    </thead>
    <tbody>
        <td>${ud.req?.req_Job_Title}</td>
        <td>${ud.req?.req_Duration}</td>
        <td>${location}</td>
        <td>${ud.req?.job_Type !== undefined ? Job_Type[ud.req.job_Type] : ""}</td>
        <td>${ud.req?.req_Rate}</td>
        <td>${ud.req?.req_EndClient === undefined ? "" : ud.req?.req_EndClient}</td>
        <td>${ud.req?.industry_Name === undefined ? "" : ud.req?.industry_Name}</td>
        <td>${ud.req?.req_Term !== undefined ? Req_Term[ud.req.req_Term] : ""}</td>
        <td>${ud.req?.req_NoOfPositions}</td>
        <td>${ud.req?.req_Category_Name}</td>
        <td>${ud.req?.req_Priority !== undefined ? Req_Priority[ud.req.req_Priority] : ""}</td>
        <td>${ud.req?.travelReq}</td>
        <td>${ud.req?.visa}</td>
        <td>${ud.req?.req_InterviewProcess !== undefined ? Interview_Process[ud.req.req_InterviewProcess] : ""}</td>
        <td>${ud.req?.req_RequiredSkill}</td>
    </tbody>
</table>
<p><b>Job Description -</b> \n${ud.req?.req_JobDescription}</p>`} />
                    <p className="mt-3"><b>Additional Info -</b> <br /><br /> {body}</p>
                    {/* {ud.req?.additional_info && <CKEditor disabled editor={ClassicEditor} data={ud.req?.additional_info} />} */}
                </div>
            })}
            <Dialog visible={openJDUn} style={{ width: '80vw' }} header={<span>JD Explanation Details of Requirement ID - {(props?.typePOC != null && props?.typePOC != undefined && props?.typePOC === true) ? "" : props.singleData.req_ID}</span>} className="p-fluid" onHide={() => { setOpenJDUn(false); setSelectedLanguage("en"); stopSpeaking(); }} maximizable>
                <Toolbar className="mb-1 py-0" right={rightToolbarTemplate2}></Toolbar>
                <Card>
                    {selectedLanguage === "hi" && hindiWords.map((word, index) => (
                        <span
                            key={`${word}-${index}`}
                            style={{ backgroundColor: index === currentWordIndex ? "#ecfc5c" : "", color: index === currentWordIndex ? "red" : "" }}
                        // className={
                        //     index === currentWordIndex
                        //         ? "jd-spoken-word"
                        //         : ""
                        // }
                        >
                            {word}{" "}
                        </span>
                    ))}
                    {selectedLanguage === "en" && englishWords.map((word, index) => (
                        <span
                            key={`${word}-${index}`}
                            style={{ backgroundColor: index === currentWordIndex ? "#ecfc5c" : "", color: index === currentWordIndex ? "red" : "" }}
                        // className={
                        //     index === currentWordIndex
                        //         ? "jd-spoken-word"
                        //         : ""
                        // }
                        >
                            {word}{" "}
                        </span>
                    ))}
                </Card>
                <div className="flex gap-1">
                    {!isSpeaking && (
                        <Button type="button" onClick={() => {
                            const textWord = (selectedLanguage === "en" ? (jdUnderstanding.aI_Response || "") : (jdUnderstanding.aI_Response_Hindi || ""));
                            speakText(textWord);
                        }}>
                            🔊 Listen
                        </Button>
                    )}

                    {isSpeaking && !isPaused && (
                        <>
                            <Button type="button" style={{ width: "7rem" }} onClick={pauseSpeaking}>
                                ⏸ Pause
                            </Button>

                            <Button type="button" style={{ width: "7rem", marginLeft: "10px" }} onClick={stopSpeaking}>
                                ⏹ Stop
                            </Button>
                        </>
                    )}

                    {isSpeaking && isPaused && (
                        <>
                            <Button type="button" style={{ width: "8rem" }} onClick={resumeSpeaking}>
                                ▶ Resume
                            </Button>

                            <Button type="button" style={{ width: "7rem", marginLeft: "10px" }} onClick={stopSpeaking}>
                                ⏹ Stop
                            </Button>
                        </>
                    )}
                </div>
            </Dialog>
        </Dialog>
    );
}
